import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const overlayStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  left: 0,
  top: 0,
  zIndex: 1000,
  width: '100%',
  height: '100%',
  background: 'rgba(0,0,0,.2)',
  textAlign: 'center',
};

const progressBarStyle = {
  width: 120,
  height: 120,
};

const progressTextStyle = { fontSize: '1.25rem', fontWeight: 'bold' };

const ProgressBar = ({ uploading, saving, progress }) => {
  if (uploading || saving) {
    return (
      <div style={overlayStyle}>
        {uploading && !saving && (
          <div>
            <h2>Uploading File</h2>
            <Box position="relative" display="inline-flex">
              <CircularProgress variant="static" value={progress} style={progressBarStyle} />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography style={progressTextStyle}>{progress || 0}%</Typography>
              </Box>
            </Box>
          </div>
        )}
        {saving && (
          <div>
            <h2>Saving...</h2>
            <CircularProgress style={progressBarStyle} />
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default ProgressBar;
